<template>
  <div class="w-full h-full" v-loading="loadEngineLoading">
    <video id="clip_video" class="w-full h-full" autoplay playsinline muted></video>
  </div>
</template>

<script>
import { cloudRender } from 'wiz-cloud-render-vulkan'
import { generateGUID, downloadFile } from '../../../assets/js/preview/publicMethods'

const render = new cloudRender()

export default {
  props: {
    md5: {
      type: String,
      defalut: '',
    },
    fileId: {
      type: String,
      defalut: '',
    },
    type: {
      type: String,
      defalut: '',
    },
  },
  data() {
    return {
      player: null,
      loadEngineLoading: false,
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloudProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloudServerPath() {
      return this.modelSetting.cloudServerPathVulkan || '192.168.20.79:7082'
    },
    handoverServerConfig() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.handoverServerConfig || {}
      )
    },
  },
  methods: {
    // 加载引擎
    async loadEngine() {
      try {
        this.loadEngineLoading = true
        const engineId = generateGUID()
        const param = {
          signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
          options: {
            videoDom: document.getElementById('clip_video'),
            userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
            engineId, // 引擎会话id，如果已存在则连接，没有则创建，会话在断开连接后超时自动关闭
            exitTimeout: 1000 * 60, // 用户超时后多久断开会话
            maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
            // openDebug: true,
          },
        }
        const { data } = await render.Engine.loadEngine(param)
        this.player = data.getDataInfo()
        render.Dispatch.on('Engine', async (e) => {
          if (e.type === 'UserTimeOut') {
            // 用户操作超时
            console.error('用户操作超时')
          }
          if (e.type === 'TimeOutExit') {
            // 断开会话
            console.error('超时断开')
          }
        })
        this.loadEngineSucces = true
        this.loadEngineLoading = false
        this.loadModelSdk()
      } catch (error) {
        this.$message.error(error)
      }
    },
    // 加载模型
    async loadModelSdk() {
      render.Dispatch.on('loadNode', this.loadModelConnect)
      const md5 = this.md5.toLowerCase()
      const query = {
        targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${md5}/${md5}.${this.type}`,
        fileUrl: `${this.handoverServerConfig.baseUrl}/api/std/file/${this.fileId}`,
        tempPath: `data://../temps/models/${md5}/${md5}.${this.type}`,
        options: {
          nodeId: md5,
          httpOptions: {
            methods: 'GET',
            header: {
              Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
            },
          },
        },
      }
      console.log('加载模型参数', query)
      const res = await render.Node.addNode(query)
      console.log('模型加载结果', res)
    },
    // 加载、下载进度
    loadModelConnect(res) {
      console.log('加载进度', res)
      if (res.status && res.data && res.data.type === 'nodeStatus') {
        switch (res.data.currentState) {
          case 4:
            render.Dispatch.off('loadNode', this.loadModelConnect)
            const nodeRes = render.Node.getInfo(this.md5.toLowerCase())
            console.log('Node信息============', nodeRes)
            this.player.Native.Camera.moveToNode(nodeRes.data.dataInfo.node, 2, 5)
            break
          default:
            break
        }
      } else if (!res.status) {
        this.$message.warning(res.message)
      }
    },
  },
  async mounted() {
    this.loadEngine()
  },
  beforeDestroy() {
    render.Engine.destroyEngine()
  },
}
</script>
